import React, { useState, useEffect } from 'react';
import { get, post } from '../core/http';
import { API } from '../core/constants';
import Modal from './ui/Modal';

const AssignArticleDialog = ({ article, onAssigned }) => {
  const [options, setOptions] = useState([]);

  const handleEventClick = async (eventId) => {
    try {
      const result = await post(`${API}/articles`).send({
        title: article.title,
        summary: article.summary || '',
        tags: article.tags || '',
        categories: '',
        url: article.url,
        status: 'publish',
        external: true,
        cover: '',
        eventId,
        domain: article.domain,
        date: article.date || '',
        source: article.source || '',
        byline: article.byline || null,
        aiGenerated: article.aiGenerated || false,
        aiMatchReason: article.aiMatchReason || null,
      });

      if (result.body) {
        console.log('done');
        await post(`${API}/unsorted/${article.id}/archive`);
        onAssigned(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const getEventOptions = async () => {
      const result = await get(`${API}/event-options`);

      if (result.body) {
        setOptions(result.body);
      }
    };

    getEventOptions();
  }, []);

  const suggested = article.aiMatchedEventId
    ? options.find((option) => option.id === article.aiMatchedEventId)
    : null;
  const rest = suggested ? options.filter((option) => option.id !== suggested.id) : options;

  return (
    <Modal title="Available events" onClose={() => onAssigned(false)}>
      {!options.length ? (
        <p className="text-center text-sm text-base-content/60 py-6">Loading...</p>
      ) : (
        <div className="max-h-[420px] overflow-y-auto space-y-1.5">
          {suggested && (
            <div>
              <p className="text-xs text-accent mb-1">
                AI-suggested match{article.aiMatchReason ? `: ${article.aiMatchReason}` : ''}
              </p>
              <button
                className="btn btn-primary btn-sm w-full justify-start"
                onClick={() => handleEventClick(suggested.id)}
              >
                ⭐ {suggested.title}
              </button>
            </div>
          )}
          {rest.map((event) => (
            <button
              key={event.id}
              className="btn btn-ghost btn-sm w-full justify-start border border-base-300"
              onClick={() => handleEventClick(event.id)}
            >
              {event.title}
            </button>
          ))}
        </div>
      )}
    </Modal>
  );
};

export default AssignArticleDialog;
